import * as cart from './cart/CartActions';
import * as toast from './toast/ToastActions';
import * as notification from './notification/NotificationActions';
import * as overlayActions from './overlay/OverlayActions';
import * as hamburgerActions from './side-nav/hamburger/HamburgerNavActions';
import * as sideNavActions from './side-nav/SideNavActions';
import * as domAction from './dom/DOMActions';
import { switchWebsite } from './website/SwitchWebsiteActions';

export default {
  ...toast,
  ...notification,
  ...cart,
  ...overlayActions,
  ...hamburgerActions,
  ...sideNavActions,
  ...domAction,
  switchWebsite,
};
